import React from 'react';

function OnboardingChecklist({
  isVisible,
  isExpanded,
  completedCount,
  description = 'Track the highest-priority next steps without leaving the dashboard.',
  totalCount,
  pendingSteps,
  onToggleExpanded,
  onDismiss,
  title = 'Setup Assistant'
}) {
  if (!isVisible) return null;

  return (
    <div className="section-card onboarding-card setup-hub-card">
      <div className="card-title-row setup-hub-title-row">
        <h3>{title}</h3>
        <div className="setup-hub-actions">
          <span className="badge">{completedCount}/{totalCount} complete</span>
          <button
            type="button"
            className="btn-edit"
            onClick={onToggleExpanded}
          >
            {isExpanded ? 'Collapse' : 'Expand'}
          </button>
          <button
            type="button"
            className="btn-delete"
            onClick={onDismiss}
          >
            Dismiss
          </button>
        </div>
      </div>
      <p className="helper-text">
        {description}
      </p>
      {!isExpanded ? (
        <div className="setup-hub-collapsed">
          <strong>
            Next step: {pendingSteps[0]?.label || 'All core setup steps are complete.'}
          </strong>
        </div>
      ) : (
        <div className="onboarding-list">
          {pendingSteps.slice(0, 3).map((step) => (
            <div key={step.id} className="onboarding-item">
              <div className="onboarding-item-copy">
                <strong>Next: {step.label}</strong>
                <p>{step.detail}</p>
              </div>
              <button type="button" className="btn-edit" onClick={step.action}>
                {step.actionLabel}
              </button>
            </div>
          ))}
          {pendingSteps.length > 3 && (
            <p className="helper-text" style={{ margin: 0 }}>
              +{pendingSteps.length - 3} more step(s) pending.
            </p>
          )}
        </div>
      )}
    </div>
  );
}

export default OnboardingChecklist;
